import { ViewInterface } from './viewInterface.js';

const FIELD_LABELS = {
  any: '不限',
  fictional: '虚拟人物',
  science: '科学',
  art: '艺术',
  sports: '体育',
  politics: '政治',
  business: '商业',
  entertainment: '娱乐',
  literature: '文学',
  military: '军事',
  other: '其他',
};

const DIFFICULTY_LABELS = {
  easy: '简单',
  medium: '中等',
  hard: '困难',
};

const GAME_MODE_LABELS = {
  celebrity: '名人猜猜猜',
  detective: '海龟汤',
};

const ANSWER_LABELS = {
  yes: '是',
  no: '否',
  unknown: '不确定',
  irrelevant: '无关',
};

export class StealthView extends ViewInterface {
  constructor(container) {
    super(container);
    this.isLoading = false;
    this.inputMode = 'question';
    this.plusMenuOpen = false;
    this.modelMenuOpen = false;
  }

  init() {
    this.cacheElements();
    this.bindEvents();
  }

  cacheElements() {
    this.els = {
      // 弹窗设置元素（与 normalView 共用 DOM）
      settingsModal: document.getElementById('settings-modal'),
      settingsModalBackdrop: document.getElementById('settings-modal-backdrop'),
      settingsModalClose: document.getElementById('settings-modal-close'),
      provider: document.getElementById('provider'),
      baseURL: document.getElementById('baseURL'),
      apiKey: document.getElementById('apiKey'),
      model: document.getElementById('model'),
      temperature: document.getElementById('temperature'),
      temperatureValue: document.getElementById('temperature-value'),
      difficulty: document.getElementById('difficulty'),
      field: document.getElementById('field'),
      gameMode: document.getElementById('game-mode'),
      saveApiKey: document.getElementById('saveApiKey'),
      stealthMode: document.getElementById('stealth-mode'),
      stealthTheme: document.getElementById('stealth-theme'),
      saveSettings: document.getElementById('save-settings'),
      testConnection: document.getElementById('test-connection'),
      settingsMessage: document.getElementById('settings-message'),

      summaryProvider: document.getElementById('summary-provider'),
      summaryModel: document.getElementById('summary-model'),
      summaryDifficulty: document.getElementById('summary-difficulty'),
      summaryField: document.getElementById('summary-field'),
      summaryMode: document.getElementById('summary-mode'),

      // 摸鱼模式专属元素
      stealthModelName: document.getElementById('stealth-model-name'),
      stealthModelBtn: document.getElementById('stealth-model-btn'),
      stealthModelMenu: document.getElementById('stealth-model-menu'),
      stealthModelDisplay: document.getElementById('stealth-model-display'),
      stealthModelQuestion: document.querySelector('#stealth-model-menu [data-action="question"]'),
      stealthModelGuess: document.querySelector('#stealth-model-menu [data-action="guess"]'),

      stealthWelcome: document.getElementById('stealth-welcome'),
      stealthChat: document.getElementById('stealth-chat'),

      stealthPlusBtn: document.getElementById('stealth-plus-btn'),
      stealthPlusMenu: document.getElementById('stealth-plus-menu'),
      stealthPlusNewGame: document.getElementById('stealth-plus-new-game'),
      stealthPlusSettings: document.getElementById('stealth-plus-settings'),
      stealthPlusGiveUp: document.getElementById('stealth-plus-give-up'),

      stealthChatInput: document.getElementById('stealth-chat-input'),
      stealthSendBtn: document.getElementById('stealth-send-btn'),
      stealthInputHint: document.getElementById('stealth-input-hint'),
      stealthGameMessage: document.getElementById('stealth-game-message'),
    };
  }

  bindEvents() {
    // 共享设置面板的事件由 NormalView 统一绑定，避免重复触发。
    // StealthView 只绑定摸鱼模式专属元素和打开弹窗的入口。

    this.els.stealthPlusBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.togglePlusMenu();
    });

    this.els.stealthPlusNewGame.addEventListener('click', () => {
      this.closePlusMenu();
      this.emit('newGame');
    });

    this.els.stealthPlusSettings.addEventListener('click', () => {
      this.closePlusMenu();
      this.openSettingsModal();
    });

    this.els.stealthPlusGiveUp.addEventListener('click', () => {
      this.closePlusMenu();
      this.emit('giveUp');
    });

    this.els.stealthModelBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggleModelMenu();
    });

    this.els.stealthModelQuestion.addEventListener('click', () => {
      this.setInputMode('question');
      this.closeModelMenu();
    });

    this.els.stealthModelGuess.addEventListener('click', () => {
      this.setInputMode('guess');
      this.closeModelMenu();
    });

    this.els.stealthSendBtn.addEventListener('click', () => {
      this.emit(this.inputMode === 'guess' ? 'guessSubmit' : 'questionSubmit');
    });

    this.els.stealthChatInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        this.emit(this.inputMode === 'guess' ? 'guessSubmit' : 'questionSubmit');
      }
    });

    this.els.stealthChatInput.addEventListener('input', () => this.autoResizeChatInput());

    this.els.stealthTheme?.addEventListener('change', () => {
      this.applyTheme(this.els.stealthTheme.value);
    });

    // 点击页面其他区域关闭菜单
    document.addEventListener('click', () => {
      this.closePlusMenu();
      this.closeModelMenu();
    });
  }

  emit(eventName, data) {
    const cb = this.callbacks[eventName];
    if (cb) cb(data);
  }

  openSettingsModal() {
    this.els.settingsModal.hidden = false;
    this.els.settingsModalClose.focus();
  }

  closeSettingsModal() {
    this.els.settingsModal.hidden = true;
  }

  togglePlusMenu() {
    this.plusMenuOpen = !this.plusMenuOpen;
    this.els.stealthPlusMenu.hidden = !this.plusMenuOpen;
    if (this.plusMenuOpen) this.closeModelMenu();
  }

  closePlusMenu() {
    this.plusMenuOpen = false;
    this.els.stealthPlusMenu.hidden = true;
  }

  toggleModelMenu() {
    this.modelMenuOpen = !this.modelMenuOpen;
    this.els.stealthModelMenu.hidden = !this.modelMenuOpen;
    if (this.modelMenuOpen) this.closePlusMenu();
  }

  closeModelMenu() {
    this.modelMenuOpen = false;
    this.els.stealthModelMenu.hidden = true;
  }

  setInputMode(mode, isDetective = this.isDetective) {
    this.inputMode = mode;
    if (isDetective) {
      this.els.stealthChatInput.placeholder = mode === 'guess'
        ? '输入你对汤底的还原...'
        : '向 AI 助手提问...';
      this.els.stealthInputHint.textContent = mode === 'guess'
        ? '按 Enter 还原汤底'
        : '按 Enter 发送提问';
    } else {
      this.els.stealthChatInput.placeholder = mode === 'guess'
        ? '输入你猜测的名人...'
        : '向 AI 助手提问...';
      this.els.stealthInputHint.textContent = mode === 'guess'
        ? '按 Enter 提交最终答案'
        : '按 Enter 发送提问';
    }
    this.els.stealthModelQuestion.classList.toggle('active', mode === 'question');
    this.els.stealthModelGuess.classList.toggle('active', mode === 'guess');
  }

  applyTheme(theme) {
    document.body.classList.remove('stealth-theme-dark', 'stealth-theme-light');
    document.body.classList.add(`stealth-theme-${theme || 'dark'}`);
  }

  onProviderChange() {
    const provider = this.els.provider.value;
    if (provider === 'anthropic') {
      this.els.baseURL.value = 'https://api.anthropic.com';
      this.els.model.value = 'claude-3-5-sonnet-20241022';
    } else if (provider === 'qwen') {
      this.els.baseURL.value = 'https://dashscope.aliyuncs.com/compatible-mode/v1';
      this.els.model.value = 'qwen-plus';
    } else if (provider === 'deepseek') {
      this.els.baseURL.value = 'https://api.deepseek.com';
      this.els.model.value = 'deepseek-v4-flash';
    } else {
      this.els.baseURL.value = 'https://api.openai.com/v1';
      this.els.model.value = 'gpt-4.1-mini';
    }
    this.updateSettingsSummaryFromUI();
  }

  updateSettingsSummaryFromUI() {
    this.els.summaryProvider.textContent = this.els.provider.options[this.els.provider.selectedIndex].text;
    this.els.summaryModel.textContent = this.els.model.value || '-';
    this.els.summaryDifficulty.textContent = this.els.difficulty.options[this.els.difficulty.selectedIndex].text;
    this.els.summaryField.textContent = this.els.field.options[this.els.field.selectedIndex].text;
    this.els.summaryMode.textContent = this.els.gameMode.options[this.els.gameMode.selectedIndex].text;
  }

  getSettings() {
    return {
      provider: this.els.provider.value,
      baseURL: this.els.baseURL.value.trim(),
      apiKey: this.els.apiKey.value.trim(),
      model: this.els.model.value.trim(),
      temperature: parseFloat(this.els.temperature.value),
      difficulty: this.els.difficulty.value,
      field: this.els.field.value,
      gameMode: this.els.gameMode.value,
      saveApiKey: this.els.saveApiKey.checked,
      stealthMode: this.els.stealthMode.value === 'true',
      stealthTheme: this.els.stealthTheme?.value || 'dark',
    };
  }

  setSettings(config) {
    this.els.provider.value = config.provider;
    this.els.baseURL.value = config.baseURL;
    this.els.apiKey.value = config.apiKey;
    this.els.model.value = config.model;
    this.els.temperature.value = config.temperature;
    this.els.temperatureValue.textContent = config.temperature;
    this.els.difficulty.value = config.difficulty;
    this.els.field.value = config.field;
    this.els.gameMode.value = config.gameMode || 'celebrity';
    this.els.saveApiKey.checked = config.saveApiKey;
    this.els.stealthMode.value = config.stealthMode ? 'true' : 'false';
    if (this.els.stealthTheme) {
      this.els.stealthTheme.value = config.stealthTheme || 'dark';
    }
    this.applyTheme(config.stealthTheme || 'dark');
    this.updateSettingsSummaryFromUI();
  }

  updateSettingsSummary(config) {
    this.els.summaryProvider.textContent = this.els.provider.querySelector(`[value="${config.provider}"]`)?.textContent || config.provider;
    this.els.summaryModel.textContent = config.model || '-';
    this.els.summaryDifficulty.textContent = DIFFICULTY_LABELS[config.difficulty] || config.difficulty;
    this.els.summaryField.textContent = FIELD_LABELS[config.field] || config.field;
    this.els.summaryMode.textContent = GAME_MODE_LABELS[config.gameMode] || config.gameMode;
    this.els.stealthModelName.textContent = config.model || '-';
    this.els.stealthModelDisplay.textContent = `模型：${config.model || '-'}`;
  }

  showSettingsMessage(message, type = 'info') {
    this.els.settingsMessage.textContent = message;
    this.els.settingsMessage.className = `message ${type}`;
    setTimeout(() => {
      this.els.settingsMessage.textContent = '';
      this.els.settingsMessage.className = 'message';
    }, 5000);
  }

  showGameMessage(message, type = 'info') {
    this.els.stealthGameMessage.textContent = message;
    this.els.stealthGameMessage.className = `message ${type}`;
    setTimeout(() => {
      this.els.stealthGameMessage.textContent = '';
      this.els.stealthGameMessage.className = 'message';
    }, 5000);
  }

  clearGameMessage() {
    this.els.stealthGameMessage.textContent = '';
    this.els.stealthGameMessage.className = 'message';
  }

  getChatInput() {
    return this.els.stealthChatInput.value.trim();
  }

  clearChatInput() {
    this.els.stealthChatInput.value = '';
    this.autoResizeChatInput();
  }

  autoResizeChatInput() {
    const el = this.els.stealthChatInput;
    el.style.height = 'auto';
    el.style.height = `${Math.min(el.scrollHeight, 200)}px`;
  }

  render(state, config) {
    this.updateSettingsSummary(config);
    this.applyTheme(config.stealthTheme || 'dark');

    const isDetective = config.gameMode === 'detective';
    this.isDetective = isDetective;

    const hasTarget = !!state.target;
    this.els.stealthWelcome.hidden = hasTarget;
    this.els.stealthChat.hidden = !hasTarget;

    if (!hasTarget) {
      this.els.stealthChat.innerHTML = '';
      this.setChatInputsEnabled(false);
      this.setInputMode('question', isDetective);
      this.els.stealthPlusGiveUp.disabled = true;
      return;
    }

    this.renderChat(state, isDetective);
    this.renderStageMessage(state, isDetective);

    const canPlay = state.stage === 'playing';
    this.setChatInputsEnabled(canPlay);
    this.els.stealthPlusGiveUp.disabled = !canPlay || this.isLoading;

    if (!canPlay) {
      this.els.stealthInputHint.textContent = '本轮已结束，点击 + 开始新对话';
    } else {
      this.setInputMode(this.inputMode, isDetective);
    }
  }

  renderChat(state, isDetective) {
    const { history, target } = state;

    let html = '';

    if (isDetective && target) {
      html += this.renderSystemMessage(`<strong>${escapeHtml(target.title)}</strong><br>${escapeHtml(target.description)}`);
    } else if (history.length === 0) {
      html += this.renderSystemMessage('新会话已开始。你可以通过提问来缩小范围，或直接给出答案。');
    }

    for (const h of history) {
      if (h.type === 'question') {
        html += this.renderUserMessage(h.input);
        const answerLabel = ANSWER_LABELS[h.answer] || h.answer;
        html += this.renderAssistantMessage(`<span class="answer-badge answer-${h.answer}">${answerLabel}</span> ${escapeHtml(h.feedback)}`);
      } else if (h.type === 'guess') {
        html += this.renderUserMessage(h.input);
        if (h.correct) {
          html += this.renderAssistantMessage(`🎉 ${escapeHtml(h.feedback)}`);
        } else if (h.input === '（放弃）') {
          html += this.renderSystemMessage(`😢 ${escapeHtml(h.feedback)}`);
        } else {
          html += this.renderAssistantMessage(`❌ 不对，${escapeHtml(h.feedback)}`);
        }
      }
    }

    if (state.stage === 'won') {
      if (isDetective && target?.fullStory) {
        html += this.renderSystemMessage(`🎉 恭喜你还原了汤底！<br><br>汤底：<br><br>${formatMultiline(target.fullStory)}`);
      }
    } else if (state.stage === 'lost') {
      if (isDetective && target?.fullStory) {
        html += this.renderSystemMessage(`😢 本轮已结束。汤底：<br><br>${formatMultiline(target.fullStory)}`);
      } else if (!isDetective && target?.name) {
        html += this.renderSystemMessage(`😢 本轮已结束。正确答案是：${escapeHtml(target.name)}`);
      }
    }

    this.els.stealthChat.innerHTML = html;
    this.scrollToBottom();
  }

  renderUserMessage(text) {
    return `
      <div class="stealth-message user">
        <div class="stealth-bubble">${escapeHtml(text)}</div>
      </div>
    `;
  }

  renderAssistantMessage(html) {
    return `
      <div class="stealth-message assistant">
        <div class="stealth-bubble">${html}</div>
      </div>
    `;
  }

  renderSystemMessage(text) {
    return `
      <div class="stealth-message system">
        <div class="stealth-bubble">${text}</div>
      </div>
    `;
  }

  renderStageMessage(state, isDetective) {
    if (state.stage === 'won') {
      const last = state.history[state.history.length - 1];
      const winText = isDetective ? '恭喜你还原了汤底！' : '恭喜你猜对了！';
      this.showGameMessage(`🎉 ${winText}${last?.feedback || ''}`, 'success');
    } else if (state.stage === 'lost') {
      if (isDetective) {
        this.showGameMessage('😢 本轮结束，汤底已在对话中给出', 'error');
      } else {
        const answer = state.target?.name ? `正确答案是：${state.target.name}` : '';
        this.showGameMessage(`😢 本轮结束。${answer}`, 'error');
      }
    } else {
      const lastGuess = [...state.history].reverse().find(h => h.type === 'guess');
      if (lastGuess && lastGuess.input !== '（放弃）') {
        this.showGameMessage(`❌ 不对，${lastGuess.feedback}`, 'info');
      } else {
        this.clearGameMessage();
      }
    }
  }

  setLoading(loading, state) {
    this.isLoading = loading;
    const canPlay = state?.stage === 'playing';

    this.els.stealthChatInput.disabled = loading || !canPlay;
    this.els.stealthSendBtn.disabled = loading || !canPlay;
    this.els.stealthPlusNewGame.disabled = loading;
    this.els.stealthPlusGiveUp.disabled = loading || !canPlay;

    if (loading) {
      this.appendTypingIndicator();
    } else {
      this.removeTypingIndicator();
    }
  }

  setChatInputsEnabled(enabled) {
    this.els.stealthChatInput.disabled = !enabled || this.isLoading;
    this.els.stealthSendBtn.disabled = !enabled || this.isLoading;
  }

  appendTypingIndicator() {
    if (document.getElementById('stealth-typing')) return;
    this.els.stealthChat.insertAdjacentHTML('beforeend', `
      <div id="stealth-typing" class="stealth-typing">
        <span>AI 正在思考</span>
        <div class="stealth-typing-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    `);
    this.scrollToBottom();
  }

  removeTypingIndicator() {
    const el = document.getElementById('stealth-typing');
    if (el) el.remove();
  }

  scrollToBottom() {
    const main = this.els.stealthChat.closest('.stealth-main');
    if (main) main.scrollTop = main.scrollHeight;
  }
}

function formatMultiline(text) {
  return escapeHtml(text).replace(/\n/g, '<br>');
}

function escapeHtml(text) {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}
